import { Injectable } from '@angular/core';

import { FuseSidebarComponent } from './sidebar.component';

@Injectable({
  providedIn: 'root'
})
export class FuseSidebarService {
  private readonly sidebarRegistry: { [key: string]: FuseSidebarComponent } = {};

  constructor() {}

  /**
   * Add the sidebar to the registry
   *
   * @param key - The key of the sidebar
   * @param sidebar - The sidebar component
   */
  register(key: string, sidebar: FuseSidebarComponent): void {
    if (this.sidebarRegistry[key]) {
      console.error(`The sidebar with the key '${key}' already exists. Either unregister it first or use a unique key.`);

      return;
    }

    this.sidebarRegistry[key] = sidebar;
  }

  /**
   * Remove the sidebar from the registry
   *
   * @param key - The key of the sidebar
   */
  unregister(key: string): void {
    if (!this.sidebarRegistry[key]) {
      console.warn(`The sidebar with the key '${key}' doesn't exist in the registry.`);
    }

    delete this.sidebarRegistry[key];
  }

  /**
   * Return the sidebar with the given key
   *
   * @param key - The key of the sidebar
   */
  getSidebar(key: string): FuseSidebarComponent {
    if (!this.sidebarRegistry[key]) {
      console.warn(`The sidebar with the key '${key}' doesn't exist in the registry.`);

      return;
    }

    return this.sidebarRegistry[key];
  }

  closeAll(): void {
    for (const key in this.sidebarRegistry) {
      if (this.sidebarRegistry.hasOwnProperty(key)) {
        this.sidebarRegistry[key].close();
      }
    }
  }
}
